export default "__VITE_ASSET__Bte7L7ao__"